var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcBlackTg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M1.90686 9.03254C1.90686 9.03254 9.64669 5.73973 12.331 4.58029C13.36 4.11651 16.8497 2.63242 16.8497 2.63242C16.8497 2.63242 18.4603 1.98314 18.326 3.55998C18.2813 4.20927 17.9234 6.48177 17.5655 8.93979C17.0286 12.4181 16.447 16.2211 16.447 16.2211C16.447 16.2211 16.3575 17.2878 15.597 17.4733C14.8364 17.6588 13.5837 16.824 13.36 16.6385C13.1811 16.4994 10.0046 14.4124 8.84139 13.392C8.52822 13.1138 8.17031 12.5572 8.88613 11.908C10.4967 10.3775 12.4205 8.47601 13.5837 7.27019C14.1206 6.71366 14.6575 5.41509 12.4205 6.99193C9.24405 9.26443 6.11232 11.3978 6.11232 11.3978C6.11232 11.3978 5.3965 11.8616 4.05433 11.4442C2.71217 11.0268 1.1463 10.4703 1.1463 10.4703C1.1463 10.4703 0.0725703 9.77459 1.90686 9.03254Z",
    fill: "#191919"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcBlackTg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_black_tg.0b05b0549cea4bc12d8c639169865a16.svg";